module.exports = __webpack_public_path__ + "img/product-image.d3298dd4.png";